<template>
  <div class="columns is-mobile">
    <div class="column is-8 is-hidden-mobile"/>
    <div class="column is-narrow">
      <div class="title is-5">
        {{ Catalog.HppTotal.Label }}
      </div>
    </div>
    <div class="column">
      <div class="has-text-right">
        <kst-value class="title is-5"
          field="HppTotal" :data="details" :catalog="Catalog"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Catalog from "../StopCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>